import { useMutation, useQueryClient } from "@tanstack/react-query"
import { fetcher } from "../fetcher"

type MutationFnParams = {
  paymentPlanConsentId: string
}

type DeclinePaymentPlanConsentProps = {
  onSuccess?: () => void
}

export function useDeclinePaymentPlanConsent({
  onSuccess = undefined,
}: DeclinePaymentPlanConsentProps) {
  const queryClient = useQueryClient()

  return useMutation<unknown, unknown, MutationFnParams>({
    mutationFn: async ({ paymentPlanConsentId }) => {
      await fetcher(
        `/Transaction/PaymentPlanConsent/${paymentPlanConsentId}/Decline`,
        {
          method: "POST",
        },
        {
          useAccessToken: true,
        }
      )
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["paymentPlanConsent"] })
      if (onSuccess) {
        onSuccess()
      }
    },
    onError: (error) => {
      console.log("error?", error)
    },
  })
}
